module.exports = {
  "country": "ME",
  "artist": "Rambo Amadeus",
  "song": "Euro Neuro",
  "year": "2012",
  "place": "NQ",
  "spotify": "7rSCbYor0FvFSjXqC6I3lR"
};